/**
 * @generated SignedSource<<5f4c0942e54862e9de288f4af6182274>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductExpireDateListItem_StoreProductExpireBatch$data = {
  readonly activeAction: {
    readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchListItemAction_StoreProductExpireBatchAction">;
  } | null;
  readonly expireAtDate: {
    readonly isoString: string;
  };
  readonly " $fragmentType": "ProductExpireDateListItem_StoreProductExpireBatch";
};
export type ProductExpireDateListItem_StoreProductExpireBatch$key = {
  readonly " $data"?: ProductExpireDateListItem_StoreProductExpireBatch$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductExpireDateListItem_StoreProductExpireBatch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductExpireDateListItem_StoreProductExpireBatch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProductExpireBatchAction",
      "kind": "LinkedField",
      "name": "activeAction",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductExpireBatchListItemAction_StoreProductExpireBatchAction"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "expireAtDate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoString",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreProductExpireBatch",
  "abstractKey": null
};

(node as any).hash = "09c0af53b55d94abcc3e232419c972f7";

export default node;
